import { render, staticRenderFns } from "./CompassCompetitorsCqw.vue?vue&type=template&id=0810a49c&scoped=true&"
import script from "./CompassCompetitorsCqw.vue?vue&type=script&lang=ts&"
export * from "./CompassCompetitorsCqw.vue?vue&type=script&lang=ts&"
import style0 from "./CompassCompetitorsCqw.vue?vue&type=style&index=0&id=0810a49c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810a49c",
  null
  
)

export default component.exports